import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Select from 'react-select';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import NoSsr from '@material-ui/core/NoSsr';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
import CancelIcon from '@material-ui/icons/Cancel';
import { emphasize } from '@material-ui/core/styles/colorManipulator';
import LinearProgress from '@material-ui/core/LinearProgress';

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  input: {
    display: 'flex',
    padding: 0,
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden',
  },
  chip: {
    margin: '${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px',
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08,
    ),
  },
  noOptionsMessage: {
    padding: '${theme.spacing.unit}px ${theme.spacing.unit * 2}px',
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    fontSize: 16,
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0,
  },
  divider: {
    height: theme.spacing.unit * 2,
  },
  iconButton: {
    position: "absolute",
    right: 40,
    top: 15
  }
});

function NoOptionsMessage(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

function Control(props) {
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  );
}

function Option(props) {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

function Placeholder(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function SingleValue(props) {
  return (
    <Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
      {props.children}
    </Typography>
  );
}

function ValueContainer(props) {
  return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}

function MultiValue(props) {
  return (
    <Chip
      tabIndex={-1}
      label={props.children}
      className={classNames(props.selectProps.classes.chip, {
        [props.selectProps.classes.chipFocused]: props.isFocused,
      })}
      onDelete={props.removeProps.onClick}
      deleteIcon={<CancelIcon {...props.removeProps} />}
    />
  );
}

function Menu(props) {
  return (
    <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
      {props.children}
    </Paper>
  );
}

const components = {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
};

function Autocomplete(props) {
    const [single, setSingle] = useState();
    const [multi, setMulti] = useState();

    const EndAdornment = props.endAdornment;

    useEffect(()=> {
      if(props.value) {
        if(props.isMulti) {
          setMulti(props.value);
        } else {
          setSingle(props.value);
        }
      }
    }, [props.value])

    var handleChange = (isMulti, value, onChange) => {
      if(value == props.value) return
        if(isMulti) {
          setMulti(value);
        } else {
            setSingle(value)
        }
        if(onChange) {
          onChange(value);
        } else {
          console.error("No está capturando el valor seleccionado. Utilice método onChange");
        }
    };
    const { classes, theme } = props;

    const selectStyles = {
        input: base => ({
        ...base,
        color: theme.palette.text.primary,
        '& input': {
            font: 'inherit',
        },
        }),
        container: (base, state) => {
          return ({
              ...base,
              zIndex: state.isFocused ? "999" : "1"  //Only when current state focused
          })
        }
    };

    return (
        <div className={classes.root}>
        <NoSsr>
            {props.cargando?<LinearProgress variant="query"/>:null}
            <Select
                classes={classes}
                options={props.suggestions}
                components={components}
                textFieldProps={{
                    label: props.label,
                    InputLabelProps: {
                      shrink: true,
                    },
                    onChange:(e) => { props.inputChange(e.target.value) }
                  }}
                value={props.isMulti ? multi : single}
                onChange={(value)=> { handleChange(props.isMulti, value, props.onChange) }}
                placeholder={props.placeholder}
                filterOption={(option, inputValue) => {
                  return option;
                }}
                isMulti={props.isMulti}
                styles={selectStyles}
                noOptionsMessage={()=>"No hay elementos"}
            />
        </NoSsr>
        </div>
    );
}

Autocomplete.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Autocomplete);